import { r as registerInstance, c as createEvent, h, H as Host } from './index-d4808923.js';

const gravityTabCss = ":host{display:none}:host(.is-active){display:block}.tab{height:100%;overflow:auto}";
const GravityTabStyle0 = gravityTabCss;

const GravityTab = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.tabChanged = createEvent(this, "tabChanged", 7);
        this.disabled = false;
        this.heading = '';
        this.tabHref = '';
        this.tabId = '';
        this.active = false;
    }
    watchHeadingHandler() {
        this.tabChanged.emit();
    }
    watchTabIdHandler() {
        this.tabChanged.emit();
    }
    /**
     * Set the active state of the tab
     * @param active
     */
    async setActive(active) {
        this.active = active;
    }
    render() {
        return (h(Host, { key: 'c4622000802bed6a9b2e7989679668a44f4091a1', class: this.active ? 'is-active' : '' }, h("div", { key: '6a6ee3ef3c73eb8bb6f17f0094b6b49f9739c86c', class: "tab", "tab-href": this.tabHref }, h("slot", { key: '238b0a502c628f75bc0d0455afa6fdc93c5335e2' }))));
    }
    static get watchers() { return {
        "heading": ["watchHeadingHandler"],
        "tabId": ["watchTabIdHandler"]
    }; }
};
GravityTab.style = GravityTabStyle0;

export { GravityTab as gravity_tab };

//# sourceMappingURL=gravity-tab.entry.js.map